module.exports = __webpack_public_path__ + "img/shipo-icon-file-download-primary.24b70419.svg";